module.exports = __webpack_public_path__ + "loading-9a22fa3d8c073a0a413af07962c4edd0.gif";


//////////////////
// WEBPACK FOOTER
// ./client/app/img/loading.gif
// module id = 611
// module chunks = 0